import React, { useState, useEffect } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import { showMessage, getToken } from "../../Functionalities/Functions";
import axios from "axios";
import FilterComponent from "../../CoreComponents/FilterComponent";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import { is_superuser, protocol } from "../../Functionalities/Config";
import { ManageSection } from "./Logic";
import { HOME_SLOTS } from "./homeSlots";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import NoImage from "../../Assets/images/no-image.png";

function Body(props) {
  //const [catData, setCatData] = useState([])
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [loading, setLoading] = useState(true);
  const [menuTab, setmenuTab] = useState(false);

  useEffect(() => {
    getData();
  }, [menuTab]);
  const getData = () => {
    showMessage(
      "Loading categories",
      "info",
      "Loading",
      "bottom",
      "bottom-left",
      0
    );
    let result = ManageSection("", "", "get", "");
    result
      .then((result) => {
        setData({
          ...data,
          data: result.data.results,
          count: result.data.count,
        });
        setLoading(false);
        setNext(result.data.next);
        setPrev(result.data.previous);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
        // void 0
      });
  };

  const handlePrev = () => {
    // alert("prev");
    var config = {
      method: "get",
      // url: prev,
      url: prev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
          count: response.data.count,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      // url: next,
      url: next.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
          count: response.data.count,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  // const categories = props.categories
  // const length = categories.length
  // void 0
  // void 0
  return (
    <>
      {!is_superuser && (
        <div class="content-body">
          {!loading ? (
            <div class="container-fluid">
              <FilterComponent
                tab={"category"}
                handleNext={handleNext}
                handlePrev={handlePrev}
                next={next}
                prev={prev}
                count={data.count}
                addItemName={"Add Section"}
                addItemPath={"/add-section"}
                MenuFunction={(e, tabValue) => {
                  tabValue === "menu" ? setmenuTab(true) : setmenuTab(false);
                }}
              />

              <div className="row">
                <div className="col-xl-12 col-xxl-12">
                  <div className="card">
                    <div className="card-body most-favourite-items pb-0">
                      <div className="tab-content">
                        <div
                          className="tab-pane fade show active"
                          id="all-categories"
                        >
                          {data.data.length > 0 ? (
                            <div className="row">
                              {data.data.map((item) => {
                                let data_image = NoImage;
                                if (item.icon) {
                                  data_image = item.icon.image;
                                }
                                return (
                                  <div id={item.id} className="col-lg-4 ">
                                    <div className="media mb-4 align-items-center applyborder">
                                      <a href={`/section/${item.id}`}>
                                        <img
                                          className="xrounded mr-3 food-img"
                                          style={{
                                            width: "3rem",
                                            height: "3rem",
                                            objectFit: "cover",
                                          }}
                                          src={data_image}
                                          alt
                                        />
                                      </a>
                                      <div className="media-body">
                                        <h5 className="mb-sm-4 mb-3">
                                          <a
                                            className="text-black"
                                            href={`/section/${item.id}`}
                                          >
                                            {item.id} :{" "}
                                            {item.section_type === "ADS"
                                              ? "Advertisement"
                                              : item.name}
                                            {item.slot && item.slot !== "NONE" && (
                                              <span className="badge badge-info light ml-2">
                                                {HOME_SLOTS.find((s) => s.value === item.slot)?.label || item.slot}
                                              </span>
                                            )}
                                            <br />
                                            {/* {item.section_type} */}
                                            <br />
                                            {item.section_type === "REGULAR"
                                              ? // "Regular"
                                                item.object_type === "BRANCH"
                                                ? `${item.is_branch.length} Restaurants`
                                                : `x items`
                                              : // "offer"
                                              item.section_type === "OFFER"
                                              ? `${item.offer.length} Offers `
                                              : item.section_type === "SALE"
                                              ? `Sale banner`
                                              : ``}
                                          </a>
                                        </h5>
                                      </div>
                                    </div>
                                    {menuTab && (
                                      <div
                                        style={{
                                          backgroundColor: "green",
                                          display: "flex",
                                          align: "center",
                                          borderRadius: "10px",
                                          textAlign: "center",
                                          position: "absolute",
                                          bottom: "5px",
                                          left: "50%",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: "white",
                                            padding: "2px",
                                          }}
                                        >
                                          Add Products
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                );
                              })}{" "}
                            </div>
                          ) : (
                            <NoDataComponent data={"Sections created"} />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <LoadingComponent />
          )}
        </div>
      )}
    </>
  );
}

function Sections() {
  const headers = "";

  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={"Sections"} subHeading={"All Sections under foodoor"} />
        <NavBar /> <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Sections;
